const embedFrameSizes = {
    CUSTOM: { label: 'Custom' },
    PRESET_1: { label: '1200x750', width: 1200, height: 750 },
    PRESET_2: { label: '960x720', width: 960, height: 720 },
    PRESET_3: { label: '800x600', width: 800, height: 600 },
    PRESET_4: { label: '640x480', width: 640, height: 480 },
};

export default embedFrameSizes;
